import ControlledComponent from '../../../utils/ControlledComponent';
import PhoneInput from './PhoneInput';

export const ControlledPhoneInput = ControlledComponent(PhoneInput);

export default PhoneInput;
